import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import Button from './Button';
import './Layout.css';

function Layout({ children, organizations = [], selectedOrg = null, onOrgSelect = null, onCreateOrg = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUserFromStorage();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleLogout = async () => {
    await authService.logout();
    navigate('/login');
  };

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠', path: '/dashboard' },
    { id: 'projects', label: 'Projects', icon: '📁', path: '/dashboard' },
    { id: 'crawls', label: 'Crawls', icon: '🔍', path: '/dashboard' },
    { id: 'reports', label: 'Reports', icon: '📊', path: '/dashboard' },
  ];

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="app-layout">
      {/* Top Header */}
      <header className="app-header">
        <div className="header-left">
          <div className="logo">
            <span className="logo-text">GEO</span>
            <span className="logo-text-accent">Audit</span>
          </div>
        </div>
        <div className="header-center">
          <div className="search-bar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            <input type="text" placeholder="Search..." />
          </div>
        </div>
        <div className="header-right">
          <div className="user-menu">
            <span className="user-name">{user?.firstName || user?.email || 'User'}</span>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="app-body">
        {/* Left Sidebar */}
        <aside className={`app-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
          <div className="sidebar-toggle" onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </div>
          
          <nav className="sidebar-nav">
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => navigate(item.path)}
              >
                <span className="nav-icon">{item.icon}</span>
                {!sidebarCollapsed && <span className="nav-label">{item.label}</span>}
              </button>
            ))}
          </nav>

          {/* Organizations Section in Sidebar */}
          {organizations.length > 0 && !sidebarCollapsed && (
            <div className="sidebar-orgs">
              <div className="sidebar-orgs-header">
                <span className="sidebar-orgs-title">Organizations</span>
                {onCreateOrg && (
                  <button className="sidebar-orgs-new" onClick={onCreateOrg} title="Create Organization">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="12" y1="5" x2="12" y2="19"></line>
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                  </button>
                )}
              </div>
              <div className="sidebar-orgs-list">
                {organizations.map((org) => (
                  <button
                    key={org.id}
                    className={`sidebar-org-item ${selectedOrg?.id === org.id ? 'active' : ''}`}
                    onClick={() => onOrgSelect && onOrgSelect(org)}
                  >
                    <div className="sidebar-org-icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                      </svg>
                    </div>
                    <div className="sidebar-org-info">
                      <span className="sidebar-org-name">{org.name}</span>
                      <span className="sidebar-org-slug">{org.slug}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </aside>

        {/* Main Content */}
        <main className="app-main">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;

